export const HUBSPOT = 'HubSpot';
export const TWILIO = 'Twilio';